import theme from "@app/theme";
import { Box, ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import router from "@app/router";
import store from "@app/store";
import { Provider } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import "./index.css";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <CssBaseline />
        <Box sx={{ marginBottom: '100px' }}>
          <RouterProvider router={router} />
        </Box>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
